/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ApiBody } from './apiBody';
import { ApiHeaders } from './apiHeaders';
import { ApiParams } from './apiParams';


export interface RelaySchemaDto { 
    contentName?: string;
    contentPartnerName?: string;
    serviceCode?: string;
    contentType: number;
    apiBaseUrl?: string;
    apiMethodType?: string;
    grantType?: string;
    apiUserName?: string;
    smppSystemId?: string;
    systemType?: string;
    smppPassword?: string;
    smppIpAddress?: string;
    smppPort?: string;
    apiKey?: string;
    urlMethod?: string;
    headers?: Array<ApiHeaders>;
    params?: Array<ApiParams>;
    bodies?: Array<ApiBody>;
}
